module.exports = __webpack_public_path__ + "img/horizontal_6_1_5012.ba84c730.png";